import React from 'react';
import { Skeleton, Space } from 'antd';
import styles from './SkeletonPage.module.css';

interface SkeletonPageProps {
  hasSidebar?: boolean;
}

export const SkeletonPage: React.FC<SkeletonPageProps> = ({ hasSidebar = true }) => {
  return (
    <div className={`${styles.shell}`}>
      {hasSidebar && (
        <div className={styles.sidebar}>
          <div className={styles.sidebarHeader}>
            <Skeleton.Button active size="large" block />
          </div>
          <div className={styles.sidebarContent}>
            <Space direction="vertical" style={{ width: '100%' }} size={24}>
              <Skeleton.Input active size="small" block />
              <Skeleton.Input active size="small" block />
              <Skeleton.Input active size="small" block />
              <Skeleton.Input active size="small" block />
            </Space>
          </div>
        </div>
      )}
      <main className={styles.main}>
        <div className={styles.header}>
          <Skeleton.Input active size="large" style={{ width: 240 }} />
          <div className={styles.headerActions}>
            <Skeleton.Button active size="default" />
            <Skeleton.Button active size="default" />
          </div>
        </div>
        <div className={styles.body}>
          <div className={styles.kpiRow}>
            <Skeleton.Button active className={styles.kpiCard} />
            <Skeleton.Button active className={styles.kpiCard} />
            <Skeleton.Button active className={styles.kpiCard} />
            <Skeleton.Button active className={styles.kpiCard} />
          </div>
          <div className={styles.section}>
            <Skeleton active paragraph={{ rows: 6 }} />
          </div>
          <div className={styles.section}>
            <Skeleton active paragraph={{ rows: 4 }} />
          </div>
        </div>
      </main>
    </div>
  );
};

export default SkeletonPage;
